module.exports = __webpack_public_path__ + "media/components/Influencers/Oauths/New/StepPage/ig_basic_display_api_sign_in-1b1707e67d9e9d9f57d71349fe2e94d3.png";